import React, { Fragment } from "react";
import Home from "./components/Layout/Home";

function App() {
  return (
    <Fragment>
      <Home />
    </Fragment>
  );
}

export default App;
